import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './ff-list.scss';
import { FFBox } from '../../containers/ff-box';

interface FFListProps {
  membersIds: string[];
  position: string;
  isMobile: boolean;
}

export const FFList: FC<FFListProps> = ({ membersIds, isMobile, ...props }) => (
  <div>
    <div className={classNames(isMobile ? '' : styles.wrapper)}>
      {membersIds.map((memberId) => (
        <FFBox memberId={memberId} key={memberId} {...props} />
      ))}
    </div>
  </div>
);
